import * as React from "react"
import ExportTableComponent from "./export-table-component"

export default class ExportTable extends React.Component<ExportTableProps, State> {
	private readonly filename: string
	private readonly years: number[]

	constructor(props: Readonly<ExportTableProps>) {
		super(props)
		const type = "ratios"
		const id = this.props.id
		const today = new Date()
		const slug = this.props.slug ? this.props.slug : ""
		const date = `${today.getFullYear()}_${today.getMonth()+1}_${today.getDate()}`
		this.filename = `${slug}_${type}_${id}_${date}`
		this.state = {
			data: [],
		}
	}

	componentDidMount() {
		if (!this.props.data) return
		this.buildData(this.props.data)
	}

	componentWillReceiveProps(props) {
		if (!props.data) return
		this.buildData(props.data)
	}

	render() {
		return <ExportTableComponent
						data={this.state.data}
						filename={this.filename}
						id={this.props.id}
						/>
	}

	/**
	 * Méthode de création des colonnes pour le fichier xlsx.
	 */
	private getColumns(): ColumnType[] {
		const years = this.props.years
		let columns: ColumnType[] = [
			{ title: "Libellé", width: { wch: 80 } },
			...years.map((y) => { return { title: y.toString() }})
		]
		return columns
	}

	/**
	 * Méthode qui génère le fichier xlsx suivant les différents chapitres cochés.
	 */
	private buildData(tableData: any[]) {
		const dataReduced: any[] = tableData.map(row => {
			const label  = row && row.label ? row.label : ""
			const style = row && row.isTitle ? { font: { bold: true } } : {}
			const dataSetChapter: RowSetType[] = [
				{ value: label},
				...this.props.years.map(y => {
					return { value: row && row[y.toString()] ? row[y.toString()] : 0 }
				})
			]
			return dataSetChapter
		})

		const columns: ColumnType[] = this.getColumns()
		const data: RowSetType[] = dataReduced

		const dataExport: DataExport[] = [{ columns, data }]
		this.setState({ data: dataExport })
	}
}

interface State {
	data: any
}

interface ExportTableProps {
	data: any
	id: string
	slug: string
	years: number[]
}

interface RowSetType {
	value: number
	style?: any
}


export interface ColumnType {
	title: string
	width?: Width
}

export interface Width {
	wch?: number
	wpx?: number
}

export interface DataExport {
	columns: ColumnType[]
	data: RowSetType[]
}



// WEBPACK FOOTER //
// ./src/component/ratios/export-table/index.tsx